const appData = {
    appVersion: "v-1.0.0",
    appProduction: true
}

export const appProduction = appData.appProduction;
export const appVersion = appData.appVersion;